import { CollectReceipt } from './components';

export const PrintTemplate = {
  CollectReceipt,
};
